import { render, staticRenderFns } from "./OrgAccess.vue?vue&type=template&id=7c3a9ce4"
import script from "./OrgAccess.vue?vue&type=script&lang=js"
export * from "./OrgAccess.vue?vue&type=script&lang=js"
import style0 from "./OrgAccess.vue?vue&type=style&index=0&id=7c3a9ce4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports